import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Tooltip, TrevorIcon } from '@trevor/ui-components';
import DropdownItem from '../util/DropdownItem';
import MultiDropdown from './MultiDropdown';
import DropdownButton from './DropdownButton';
import {
  ADD_COLUMN,
  AGGREGATE,
  GROUP_BY,
  JOIN,
  ORDER_BY,
  REARRANGE_COLUMNS,
  RENAME_COLUMNS,
  SELECT,
  WHERE,
} from '../util/enums/EnumLayers';
import { BIGQUERY, MYSQL } from '../util/enums/EnumDbType';
import { addTemplateLayer } from '../actions';
import sidebar from '../css/module/sidebar.css';
import buttons from '../css/module/buttons.css';
import flex from '../css/module/flex.css';

class AddNewStep extends Component {
  render() {
    const {
      // true if should be rendered as a list of buttons
      isDropdown, // true if should be rendered as a dropdown
      optionalLayer, // if provided, new steps will be added after this 'optionalLayer'
    } = this.props;

    const { onTemplateStepAdded, isLastStep } = this.props;

    const addStep = onTemplateStepAdded(optionalLayer);

    const columnOptions = [
      DropdownItem.action(
        <span>
          <b>show / hide</b> columns
        </span>,
        addStep(SELECT),
      ),
      DropdownItem.divider(),
      DropdownItem.action(
        <span>
          <b>rename</b> columns
        </span>,
        addStep(RENAME_COLUMNS),
      ),
      DropdownItem.action(
        <span>
          <b>reorder</b> columns
        </span>,
        addStep(REARRANGE_COLUMNS),
      ),
      DropdownItem.divider(), // TODO: remove for snowflake
      DropdownItem.action(
        <span>
          <b>add new</b> column
        </span>,
        addStep(ADD_COLUMN),
      ), // TODO: remove for snowflake
    ];

    // options for isDropdown
    const filter = DropdownItem.action(
      <span>
        <b>filter</b> rows
      </span>,
      addStep(WHERE),
    );
    const sort = DropdownItem.action(
      <span>
        <b>sort</b> rows
      </span>,
      addStep(ORDER_BY),
    );
    const summarizeAsNewColumn = DropdownItem.action(
      <span>
        <b>summarize</b> as new column
      </span>,
      addStep(GROUP_BY),
    );
    const rowOptions = [filter, sort];
    const plusOptions = [summarizeAsNewColumn];

    // options for isButtonList
    const className = `margin-right-5 ${buttons.btn} `; // + buttons.sm + ' ' + buttons.rounded;

    const text = isLastStep ? 'Add new step' : 'Insert step below';
    const id = isLastStep ? 'AddStep' : 'InsertStep';

    if (isDropdown) {
      const rows = DropdownItem.dropdown('rows', rowOptions);
      const summarize = DropdownItem.action(
        <span>summarize</span>,
        addStep(AGGREGATE),
      );
      const columns = DropdownItem.dropdown('columns', columnOptions);
      const join = DropdownItem.action(<span>join table</span>, addStep(JOIN));
      const options = [rows, summarize, columns, join];
      return (
        <DropdownButton
          contentBuilder={() => <MultiDropdown items={options} />}
        >
          <span>
            <span data-tooltip-id={id}>
              <span className="glyphicon glyphicon-plus padding-left-5 padding-right-5" />
            </span>
            <Tooltip id={id}>
              <span>{text}</span>
            </Tooltip>
          </span>
        </DropdownButton>
      );
    }

    return (
      <div
        className={`${sidebar.addStep} ${sidebar.layerInner} ${
          flex.alignItemsCenter
        } ${isLastStep ? sidebar.addStepEnd : ''}`}
      >
        <div
          className={`${sidebar.stepNumberContainer} ${flex.alignSelfStretch}`}
        >
          {[BIGQUERY, MYSQL].includes(this.props.dbType) ? (
            <div className={sidebar.stepNumber}>
              <TrevorIcon name="plus-small" />
            </div>
          ) : (
            <DropdownButton
              contentBuilder={() => <MultiDropdown items={plusOptions} />}
            >
              <div className={`${sidebar.stepNumber} user-clickable`}>
                <TrevorIcon name="plus-small" />
              </div>
            </DropdownButton>
          )}
        </div>
        <div
          className={`${sidebar.buttons} ${flex.alignItemsCenter} position-relative`}
          style={{ padding: '17px 0px 17px 10px' }}
        >
          <button className={className} onClick={addStep(ORDER_BY)}>
            sort
          </button>
          <button className={className} onClick={addStep(WHERE)}>
            filter
          </button>
          <button className={className} onClick={addStep(AGGREGATE)}>
            summarize
          </button>
          <DropdownButton
            contentBuilder={() => <MultiDropdown items={columnOptions} />}
          >
            <button type="button" className={className}>
              columns
              <TrevorIcon name="triangle-down" />
            </button>
          </DropdownButton>
          <button className={className} onClick={addStep(JOIN)}>
            join
          </button>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    dbType: state.datasource.dbType,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onTemplateStepAdded: (layerToAppendTo) => (layerType) => () => {
      dispatch(addTemplateLayer(layerType, layerToAppendTo));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AddNewStep);
